import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ShopDataService} from '@webu/data';

@Component({
  selector: 'webu-submit-cancel',
  templateUrl: './submit-cancel.component.html'
})

export class SubmitCancelComponent {
  @Input() form?: FormGroup;
  @Input() disableSaveButton = false;
  @Input() saving = false;
  @Output() saveClicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private shopDataService: ShopDataService
  ) {}

  onSaveClick() {
    this.saveClicked.emit();
  }

  getCopyByCode(code:string) {
    return this.shopDataService.getGenericCopy(code) ?? '';
  }

  cancelClick(){
    this.cancelClicked.emit();
  }
}
